import { useLocation } from 'react-router-dom';
import { appleItunesAppArgument } from 'shared/components/HelmetMetaTags';
import { environment } from 'shared/constants/common-meta';
import { getDeviceType } from 'shared/hooks/useDeviceManager';
import { isSafari } from 'shared/util/utility';

export const AppleItunesApp = () => {
	const location = useLocation();
	const device = getDeviceType();
	const shouldShowIosBanner = environment.BETFAN_APPSTORE_ID && (device?.deviceType === 'ios' || isSafari);

	if (!shouldShowIosBanner) return null;

	return <meta name="apple-itunes-app" content={`app-id=${environment.BETFAN_APPSTORE_ID}, app-argument=${appleItunesAppArgument(location)}`} />;
};
